import React, { useState, useEffect, useContext } from 'react';
import LanguageContext from 'context/LanguageContext';
import axios from 'axios';
import Spinner from 'components/Spinner/Spinner';

export default function Privacy() {
  const { language } = useContext(LanguageContext);
  const [isLoading, setIsLoading] = useState(true);
  const [privacyPolicy, setPrivacyPolicy] = useState();

  async function getPrivacy() {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}pages?per_page=100&s=privacy-policy`
      );
      setPrivacyPolicy(response.data);
      console.log(privacyPolicy);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  }

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0 });
    getPrivacy();
  }, []);
  return (
    <div className="h-full bg-white">
      <div className="container p-10 mx-auto">
        {/* Posizioni aperte */}
        {isLoading && (
          <div className="flex items-center justify-center">
            <Spinner className="w-16 h-16" />
          </div>
        )}
        {!isLoading && (
          <div
            dangerouslySetInnerHTML={{
              __html: privacyPolicy.filter((item) =>
                item.slug.includes(`privacy-policy-${language}`)
              )[0].content.rendered,
            }}
          />
        )}
      </div>
    </div>
  );
}
